import { motion } from "framer-motion"

const SvgComponent = ({transition, ...props}) => (
  <motion.svg
    initial={{
      y: '30%',
      x: '5%',
      scale: 0.55,
      opacity: 1
    }}
    animate={{
      y: '0%',
      opacity: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}

    viewBox="0 0 189 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.9}
      d="M151.649 135.062c3.341.717 6.039 3.401 6.499 6.474l9.087 60.741c.541 3.617-2.169 6.526-6.066 6.533-.056 0-.112.004-.167.012l-121.09 18.115a.93.93 0 0 1-.167.012c-3.91-.076-7.498-3.039-8.039-6.653L8.494 65.135c-.54-3.618 2.169-6.527 6.066-6.534.056 0 .112-.004.167-.012l103.054-15.417a.979.979 0 0 1 .166-.011c3.91.076 7.499 3.039 8.039 6.652l10.492 70.132c1.073 7.175 7.366 13.445 15.171 15.117z"
      fill="#D7A2F0"
    />
    <rect
      x={7.659}
      y={15.155}
      width={116.104}
      height={147.939}
      rx={2}
      transform="rotate(-3.785 7.66 15.155)"
      fill="url(#cthpiy2p6a)"
    />
    <g filter="url(#z5wefpjcrb)">
      <rect
        x={27.828}
        y={36.341}
        width={78.651}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 27.828 36.341)"
        fill="url(#6td6z0mclc)"
      />
    </g>
    <g filter="url(#m1zr9c125d)">
      <rect
        x={29.683}
        y={64.37}
        width={78.651}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 29.683 64.37)"
        fill="url(#zatisxoppe)"
      />
    </g>
    <g filter="url(#zpql4cqkpf)">
      <rect
        x={30.919}
        y={83.055}
        width={78.651}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 30.919 83.055)"
        fill="url(#khx4ygwo4g)"
      />
    </g>
    <g filter="url(#y79npchiah)">
      <rect
        x={28.446}
        y={45.684}
        width={50.561}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 28.446 45.684)"
        fill="url(#cgyii1oozi)"
      />
    </g>
    <g filter="url(#jhlvl33v1j)">
      <rect
        x={30.301}
        y={73.713}
        width={50.561}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 30.3 73.713)"
        fill="url(#xi7u0cnstk)"
      />
    </g>
    <g filter="url(#pzz5bcikul)">
      <rect
        x={31.537}
        y={92.398}
        width={50.561}
        height={5.618}
        rx={2.809}
        transform="rotate(-3.785 31.537 92.398)"
        fill="url(#6l1f6j622m)"
      />
    </g>
    <g filter="url(#gkyfyssn6n)">
      <rect
        x={71.376}
        width={116.104}
        height={147.939}
        rx={2}
        transform="rotate(13.189 71.376 0)"
        fill="url(#pmrd0d2vbo)"
      />
      <g filter="url(#0roo8231ap)">
        <rect
          x={84.481}
          y={26.152}
          width={78.651}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 84.481 26.152)"
          fill="url(#u9w3ejetuq)"
        />
      </g>
      <g filter="url(#sqboiwpu8r)">
        <rect
          x={78.072}
          y={53.5}
          width={78.651}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 78.072 53.5)"
          fill="url(#fwx9jisbfs)"
        />
      </g>
      <g filter="url(#nu4s68tunt)">
        <rect
          x={73.8}
          y={71.733}
          width={78.651}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 73.8 71.733)"
          fill="url(#lq8392bilu)"
        />
      </g>
      <g filter="url(#n6ljh3a48v)">
        <rect
          x={82.345}
          y={35.268}
          width={50.561}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 82.345 35.268)"
          fill="url(#lef02is3qw)"
        />
      </g>
      <g filter="url(#ioob0fwbpx)">
        <rect
          x={75.936}
          y={62.617}
          width={50.561}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 75.936 62.617)"
          fill="url(#j14t00v85y)"
        />
      </g>
      <g filter="url(#l6sy4n4ljz)">
        <rect
          x={71.663}
          y={80.849}
          width={50.561}
          height={5.618}
          rx={2.809}
          transform="rotate(13.189 71.663 80.849)"
          fill="url(#g90qm909zA)"
        />
      </g>
    </g>
    <g opacity={0.8} filter="url(#bfbqzknt8B)">
      <path
        d="M146.694 154.357c2.78-.163 4.949 1.724 5.233 4.552l5.627 55.896c.338 3.353-2.067 6.853-5.368 7.824L25.568 235.202c-4.068.409-6.252-.962-6.59-4.311L1.079 81.337c-.337-3.353 2.068-6.853 5.368-7.824L119.922 60.36c3.301-.971 6.253.962 6.59 4.31l7.958 79.055c.665 6.603 5.733 11.013 12.224 10.631z"
        fill="url(#ujmtrgnweC)"
      />
    </g>
    <defs>
      <linearGradient
        id="cthpiy2p6a"
        x1={82.616}
        y1={25.408}
        x2={42.516}
        y2={139.105}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="6td6z0mclc"
        x1={112.214}
        y1={40.087}
        x2={23.73}
        y2={39.37}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="zatisxoppe"
        x1={114.068}
        y1={68.115}
        x2={25.584}
        y2={67.398}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="khx4ygwo4g"
        x1={115.305}
        y1={86.801}
        x2={26.821}
        y2={86.084}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="cgyii1oozi"
        x1={82.694}
        y1={49.43}
        x2={25.81}
        y2={49.133}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="xi7u0cnstk"
        x1={84.549}
        y1={77.458}
        x2={27.664}
        y2={77.162}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="6l1f6j622m"
        x1={85.785}
        y1={96.143}
        x2={28.9}
        y2={95.847}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="pmrd0d2vbo"
        x1={24.56}
        y1={92.462}
        x2={346.775}
        y2={63.005}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="u9w3ejetuq"
        x1={168.867}
        y1={29.897}
        x2={80.383}
        y2={29.18}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="fwx9jisbfs"
        x1={162.458}
        y1={57.246}
        x2={73.974}
        y2={56.529}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="lq8392bilu"
        x1={158.186}
        y1={75.478}
        x2={69.702}
        y2={74.761}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="lef02is3qw"
        x1={136.593}
        y1={39.013}
        x2={79.708}
        y2={38.717}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="j14t00v85y"
        x1={130.184}
        y1={66.362}
        x2={73.299}
        y2={66.066}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="g90qm909zA"
        x1={125.911}
        y1={84.594}
        x2={69.026}
        y2={84.298}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="ujmtrgnweC"
        x1={65.08}
        y1={243.474}
        x2={46.633}
        y2={58.987}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <filter
        id="z5wefpjcrb"
        x={24.007}
        y={27.329}
        width={86.492}
        height={18.439}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="m1zr9c125d"
        x={25.861}
        y={55.357}
        width={86.492}
        height={18.439}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="zpql4cqkpf"
        x={27.098}
        y={74.043}
        width={86.492}
        height={18.439}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="y79npchiah"
        x={24.625}
        y={38.526}
        width={58.464}
        height={16.585}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="jhlvl33v1j"
        x={26.48}
        y={66.554}
        width={58.464}
        height={16.585}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="pzz5bcikul"
        x={27.716}
        y={85.24}
        width={58.464}
        height={16.585}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="gkyfyssn6n"
        x={34.024}
        y={0.403}
        width={153.989}
        height={177.721}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="0roo8231ap"
        x={79.766}
        y={22.718}
        width={84.726}
        height={30.283}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="sqboiwpu8r"
        x={73.356}
        y={50.066}
        width={84.726}
        height={30.283}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="nu4s68tunt"
        x={69.084}
        y={68.299}
        width={84.726}
        height={30.283}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="n6ljh3a48v"
        x={77.629}
        y={31.834}
        width={57.377}
        height={23.874}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="ioob0fwbpx"
        x={71.22}
        y={59.183}
        width={57.377}
        height={23.874}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="l6sy4n4ljz"
        x={66.947}
        y={77.415}
        width={57.377}
        height={23.874}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
      <filter
        id="bfbqzknt8B"
        x={-2.953}
        y={56.11}
        width={164.539}
        height={183.162}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10274"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10274"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
